import { useEffect } from "react";

// Hollow ring + tiny dot — tech feel, difference blend.
export function useCursor() {
  useEffect(() => {
    if (window.matchMedia("(pointer: coarse)").matches) return;

    const ring = document.createElement("div");
    ring.className = "cursor-ring";
    const dot = document.createElement("div");
    dot.className = "cursor-dot";
    document.body.appendChild(ring);
    document.body.appendChild(dot);

    let tx = 0, ty = 0, rx = 0, ry = 0, dx = 0, dy = 0;
    const onMove = (e) => { tx = e.clientX; ty = e.clientY; };
    let id;
    const raf = () => {
      // ring lags smoothly, dot is snappier
      rx += (tx - rx) * 0.18;
      ry += (ty - ry) * 0.18;
      dx += (tx - dx) * 0.55;
      dy += (ty - dy) * 0.55;
      ring.style.transform = `translate(${rx}px, ${ry}px) translate(-50%,-50%)`;
      dot.style.transform = `translate(${dx}px, ${dy}px) translate(-50%,-50%)`;
      id = requestAnimationFrame(raf);
    };
    id = requestAnimationFrame(raf);

    const over = (e) => {
      if (e.target.closest?.("a,button,[data-cursor='hover'],input,select,label,textarea"))
        ring.classList.add("hover");
      else ring.classList.remove("hover");
    };
    window.addEventListener("mousemove", onMove, { passive: true });
    window.addEventListener("mouseover", over, { passive: true });
    return () => {
      cancelAnimationFrame(id);
      window.removeEventListener("mousemove", onMove);
      window.removeEventListener("mouseover", over);
      ring.remove();
      dot.remove();
    };
  }, []);
}
